import {
  UCCO_SET_BACKEND_ERRORS,
  UCCO_INIT,
  UCCO_FILL_MATERIALS_FORM
} from './available';
import _ from 'lodash'

export default {
  [UCCO_SET_BACKEND_ERRORS] (state, errorMessagesByFields) {
    state.updateCaseCreationOrder.form.errorMessages = errorMessagesByFields
  },
  [UCCO_INIT] (state, value) {
    state.updateCaseCreationOrder = {
      ...state.updateCaseCreationOrder,
      form: {
        ...state.updateCaseCreationOrder.form,
        errorMessages: [],
        data: {
          ...value.data,
          files: _.cloneDeep(value.files),
          patientAddress: value.data.patientAddress,
          clientSpecialist: value.data.clientSpecialistId,
          services: value.data.services || [],
          externalId: value.externalId,
          receiveMaterialMethod: value.data.receiveMaterialMethod || [],
          examination: value.data.examination || null
        }
      },
      data: value
    }
  },
  [UCCO_FILL_MATERIALS_FORM] (state, materialsForm) {
    state.updateCaseCreationOrder = {
      ...state.updateCaseCreationOrder,
      materialsFormValue: materialsForm
    }
  }
}